import {User}           from "../user/user";

/**
 * Handle permissions checks against the User.permissions
 * credentials, returning true or false if the current
 * User has access.
 *
 * These values must correspond with the values in
 * permissions.py in the ReST API.
 */
export class Permissions {

	public static readonly USER_ADMIN               = 262144;
	public static readonly SUPER_USER               = 4194304;

	public static readonly NFL_PLAYER_NEWS          = 524288;
	public static readonly NFL_INACTIVES            = 1048576;
	public static readonly MANAGE_FEEDS             = 2097152;

	public static readonly CREATE_EDIT_TEAMS        = 16384;
	public static readonly DELETE_TEAMS             = 32768;

	public static readonly CREATE_EDIT_PLAYERS      = 32;
	public static readonly DELETE_PLAYERS           = 256;

	public static readonly CREATE_EDIT_TAGS         = 64;
	public static readonly DELETE_TAGS              = 512;

	public static readonly CREATE_EDIT_SOURCES      = 16;
	public static readonly DELETE_SOURCES           = 128;

	public static readonly CREATE_EDIT_POSITIONS    = 1024;
	public static readonly DELETE_POSITIONS         = 2048;

	public static readonly SEARCH_PHRASES           = 4096;
	public static readonly SPORT_CHECKBOXES         = 8192;

	public static readonly CREATE_EDIT_VENDORS      = 65536;
	public static readonly DELETE_VENDORS           = 131072;

	public static readonly VIEW_STORIES             = 8;
	public static readonly CREATE_EDIT_STORIES      = 2;
	public static readonly DELETE_STORIES           = 4;

	public static readonly VIEW_STORY_LIST          = 1;

	/**
	 * See if the current user has permission to perform the requested
	 * action.
	 * @param {number} action  The action to perform; one of the public static readonly choices in this class.
	 * @param {User}   user    A user to check permissions for; leaving it null tests the current user.
	 * @return {boolean} True if the user has permission, false otherwise.
	 */
	public static checkPermission(action:number, user:User = null):boolean {

		if (null === user) {

			let userString:string = sessionStorage.getItem('currentUser');

			// Make sure there is a proper value.
			if (null === userString) {
				return false;
			}

			user = new User(JSON.parse(userString));

		}

		// Super users can do anything.
		if ((user.permissions & Permissions.SUPER_USER) > 0) {
			return true;
		}

		// Everyone else has to be checked.
		return !!((user.permissions & action) > 0);

	}

}


// WEBPACK FOOTER //
// ./src/app/services/permissions/permissions.ts